import React, { useContext, useState } from 'react';

const LayoutContext = React.createContext();

export function useLayout() {
    return useContext(LayoutContext);
}

export function LayoutProvider({ children }) {
    const [fullWidth, setFullWidth] = useState(false);
    const [hideBanner, setHideBanner] = useState(false);

    return (
        <LayoutContext.Provider value={{ fullWidth, setFullWidth, hideBanner, setHideBanner }}>
            {children}
        </LayoutContext.Provider>
    );
}
